var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNodeJs02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#539E43;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250,432.5c-5,0-9.7-1.3-14.1-3.7l-44.6-26.5c-6.7-3.7-3.4-5-1.3-5.7c9.1-3,10.7-3.7,20.1-9.1 c1-0.7,2.3-0.3,3.4,0.3l34.2,20.5c1.3,0.7,3,0.7,4,0l133.8-77.5c1.3-0.7,2-2,2-3.7V172.6c0-1.7-0.7-3-2-3.7L251.7,91.8 c-1.3-0.7-3-0.7-4,0l-133.8,77.1c-1.3,0.7-2,2.3-2,3.7v154.6c0,1.3,0.7,3,2,3.7l36.6,21.1c19.8,10.1,32.2-1.7,32.2-13.4V186 c0-2,1.7-4,4-4h17.1c2,0,4,1.7,4,4v152.6c0,26.5-14.4,41.9-39.6,41.9c-7.7,0-13.7,0-30.8-8.4L102.1,352c-8.7-5-14.1-14.4-14.1-24.5 V173c0-10.1,5.4-19.4,14.1-24.5L235.9,71c8.4-4.7,19.8-4.7,28.2,0l133.8,77.5c8.7,5,14.1,14.4,14.1,24.5v154.6 c0,10.1-5.4,19.4-14.1,24.5l-133.8,77.5C259.7,431.5,254.7,432.5,250,432.5z M291.2,326.2c-58.7,0-70.8-26.8-70.8-49.6 c0-2,1.7-4,4-4H242c2,0,3.7,1.3,3.7,3.4c2.7,17.8,10.4,26.5,45.9,26.5c28.2,0,40.2-6.4,40.2-21.5c0-8.7-3.4-15.1-47.3-19.4 c-36.6-3.7-59.4-11.7-59.4-40.9c0-27.2,22.8-43.3,61-43.3c42.9,0,64,14.8,66.7,46.9c0,1-0.3,2-1,3c-0.7,0.7-1.7,1.3-2.7,1.3h-17.4 c-1.7,0-3.4-1.3-3.7-3c-4-18.4-14.4-24.5-41.9-24.5c-30.8,0-34.5,10.7-34.5,18.8c0,9.7,4.4,12.7,45.9,18.1 c41.2,5.4,60.7,13.1,60.7,41.9C358,309.4,333.8,326.2,291.2,326.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeJs02);
export default __webpack_public_path__ + "static/media/Node-JS-02.b7919437df4888877d47a90a60f805df.svg";
export { ForwardRef as ReactComponent };